import React, { useContext, useState } from 'react'
import TabContext from '@mui/lab/TabContext'
import { Box, Button, ButtonGroup, Grid, Tab, Tabs, Typography } from '@mui/material'
import TabPanel from '@mui/lab/TabPanel'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { useForm } from 'react-hook-form'
import UpdateAccountPasswordModal from './UpdateAccountPasswordModal'
import { UserInfoContext } from '../../contexts/UserInfoContext'
import UpdateAccountEmailModal from './UpdateAccountEmailModal'
import UpdatePhoneNumberModal from './UpdatePhoneNumberModal'

const SettingsPage = () => {
  const { userInfo, setUserInfo } = useContext(UserInfoContext)
  const [tabValue, setTabValue] = React.useState('account')
  const methods = useForm({ mode: 'onChange' })
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = methods
  const [openUpdateEmailModal, setOpenUpdateEmailModal] = useState(false)
  const [openUpdatePhoneNumberModal, setOpenUpdatePhoneNumberModal] = useState(false)
  const [openResetPasswordModal, setOpenResetPasswordModal] = useState(false)
  const [openUpdateGenderModal, setOpenUpdateGenderModal] = useState(false)
  const [openUpdateLocationModal, setOpenUpdateLocationModal] = useState(false)

  const tabHandler = (event, newValue) => {
    setTabValue(newValue)
  }

  const updateEmailModalCloseHandler = () => {
    setOpenUpdateEmailModal(false)
  }

  const updatePhoneNumberModalCloseHandler = () => {
    setOpenUpdatePhoneNumberModal(false)
  }

  const resetPasswordModalCloseHandler = () => {
    setOpenResetPasswordModal(false)
  }

  const updateGenderModalCloseHandler = () => {
    setOpenUpdateGenderModal(false)
  }

  const updateLocationModalCloseHandler = () => {
    setOpenUpdatePhoneNumberModal(false)
  }

  const AccountSettings = () => {
    return (
      <Grid container spacing={1} sx={{ ml: -4 }}>
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>General</Typography>
        </Grid>
        <Grid item xs={12}>
          <AccountGeneralSettingsButtonGroup />
        </Grid>
        {openUpdateEmailModal && <UpdateAccountEmailModal open={openUpdateEmailModal} onClose={updateEmailModalCloseHandler} />}
        {openUpdatePhoneNumberModal && <UpdatePhoneNumberModal open={openUpdatePhoneNumberModal} onClose={updatePhoneNumberModalCloseHandler} setOpenUpdatePhoneNumberModal={setOpenUpdatePhoneNumberModal} />}
        {openResetPasswordModal && <UpdateAccountPasswordModal open={openResetPasswordModal} onClose={resetPasswordModalCloseHandler} />}
      </Grid>
    )
  }

  const ProfileSettings = () => {
    return (
      <Grid container spacing={1} sx={{ ml: -4 }}>
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>General</Typography>
        </Grid>
        <Grid item xs={12}>
          <ProfileGeneralSettingsButtonGroup />
        </Grid>
      </Grid>
    )
  }

  const NotificationSettings = () => {
    return (
      <Grid container spacing={1} sx={{ ml: -4 }}>
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>General</Typography>
        </Grid>
        <Grid item xs={12}>
          <NotificationGeneralSettingsButtonGroup />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Messages</Typography>
        </Grid>
        <Grid item xs={12}>
          <NotificationMessagesSettingsButtonGroup />
        </Grid>
      </Grid>
    )
  }

  const AccountGeneralSettingsButtonGroup = () => {
    return (
      <ButtonGroup fullWidth orientation="vertical" variant="text" aria-label="General Settings button group">
        <Button
          key="emailAddress"
          onClick={() => setOpenUpdateEmailModal(true)}
          color="inherit"
          style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}
        >
          <Typography variant="body2">Email address</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2">{userInfo?.username}</Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
        <Button
          key="phoneNumber"
          onClick={() => setOpenUpdatePhoneNumberModal(true)}
          color="inherit"
          style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}
        >
          <Typography variant="body2">Phone Number</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2"></Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
        <Button
          key="password"
          onClick={() => setOpenResetPasswordModal(true)}
          color="inherit"
          style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}
        >
          <Typography variant="body2">Password</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2"></Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
        <Button
          key="gender"
          onClick={() => setOpenUpdateGenderModal(true)}
          color="inherit"
          style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}
          disabled
        >
          <Typography variant="body2">Gender</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2"></Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
        <Button
          key="location"
          onClick={() => setOpenUpdateLocationModal(true)}
          color="inherit"
          style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}
          disabled
        >
          <Typography variant="body2">Location customization</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2"></Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
      </ButtonGroup>
    )
  }

  const ProfileGeneralSettingsButtonGroup = () => {
    return (
      <ButtonGroup fullWidth orientation="vertical" variant="text" aria-label="General Settings button group" disabled>
        <Button key="displayName" color="inherit" style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}>
          <Typography variant="body2">Display Name</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2"></Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
        <Button key="aboutDescription" color="inherit" style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}>
          <Typography variant="body2">About description</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2"></Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
        <Button key="avatar" color="inherit" style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}>
          <Typography variant="body2">Avatar</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2"></Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
        <Button key="banner" color="inherit" style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}>
          <Typography variant="body2">Banner</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2"></Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
        <Button key="socialLinks" color="inherit" style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}>
          <Typography variant="body2">Social links</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2">

            </Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
      </ButtonGroup>
    )
  }

  const NotificationGeneralSettingsButtonGroup = () => {
    return (
      <ButtonGroup fullWidth orientation="vertical" variant="text" aria-label="General Settings button group" disabled>
        <Button key="communityNotifications" color="inherit" style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}>
          <Typography variant="body2">Community Notifications</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2"></Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
        <Button key="pushNotifications" color="inherit" style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}>
          <Typography variant="body2">Push Notifications</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2"></Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
      </ButtonGroup>
    )
  }

  const NotificationMessagesSettingsButtonGroup = () => {
    return (
      <ButtonGroup fullWidth orientation="vertical" variant="text" aria-label="General Settings button group" disabled>
        <Button key="privateMessages" color="inherit" style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}>
          <Typography variant="body2">Private messages</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2"></Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
        <Button key="chatMessages" color="inherit" style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}>
          <Typography variant="body2">Chat messages</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2"></Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
        <Button key="chatRequests" color="inherit" style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}>
          <Typography variant="body2">Chat requests</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2"></Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
        <Button key="markAllAsRead" color="inherit" style={{ textTransform: 'none', border: 'none', justifyContent: 'space-between' }}>
          <Typography variant="body2">Mark all as read</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="body2"></Typography>
            <ArrowForwardIosIcon fontSize="10px" sx={{ ml: 4, mt: 0.5 }} />
          </Box>
        </Button>
      </ButtonGroup>
    )
  }

  return (
    <Grid container sx={{ mt: 4 }}>
      <Grid item xs sx={{ display: { xs: 'none', lg: 'block' } }}></Grid>
      <Grid item xs sx={{ ml: 2 }}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2 }}>Settings</Typography>
          </Grid>
          <Grid item xs={12}>
            <TabContext value={tabValue}>
              <Box>
                <Tabs value={tabValue} onChange={tabHandler} aria-label="settings-tab" variant="scrollable" scrollButtons="auto">
                  <Tab label="Account" value="account" sx={{ fontWeight: 'bold' }} />
                  <Tab label="Profile" value="profile" sx={{ fontWeight: 'bold' }} />
                  {/* <Tab label="Privacy" value="privacy" sx={{ fontWeight: 'bold' }} /> */}
                  {/* <Tab label="Preferences" value="preferences" sx={{ fontWeight: 'bold' }} /> */}
                  <Tab label="Notifications" value="notifications" sx={{ fontWeight: 'bold' }} />
                  {/* <Tab label="Email" value="email" sx={{ fontWeight: 'bold' }} /> */}
                </Tabs>
              </Box>
               <TabPanel value="account">
                <AccountSettings />
               </TabPanel>
              <TabPanel value="profile">
                <ProfileSettings />
              </TabPanel>
              <TabPanel value="notifications">
                <NotificationSettings />
              </TabPanel>
            </TabContext>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs sx={{ display: { xs: 'none', lg: 'block' } }}></Grid>
    </Grid>
  )
}

export default SettingsPage
